var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"appp bg-blue"},[_c('v-app-bar',{attrs:{"color":"transparent","dense":""}},[_c('v-spacer')],1),_c('v-main',{staticClass:"main"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }